import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import LeadLink from "web/react/components/lead-link/lead-link";
import { gettext } from "web/script/modules/django-i18n";
import { BuyOptionPropType } from "web/types/buy-option";
import SVGIcon from "../svg-icon/svg-icon";
import styles from "./oos-buy-option.css";


function OOSBuyOption({ buyOption, className, isWide }) {
    let size = buyOption.sizes[buyOption.default_size];
    return (
        <LeadLink
            className={styles.linkWrapper}
            href={size.lead_url}
            openInNewTab={true}
            productId={buyOption.product_id}
            reason="affiliate-buy-on-store-button"
        >
            <div
                className={classnames(styles.optionWrapper, {
                    [styles.wideWrapper]: isWide,
                    [className]: className,
                })}
            >
                <div className={styles.optionTitle}>
                    <div className={styles.retailerName}>{buyOption.retailer_name}</div>
                    {buyOption.oos_since_human && (
                        <div className={styles.lastSeen}>
                            {buyOption.oos_since_human}
                        </div>
                    )}
                </div>
                <div className={styles.leadUrlWrapper}>
                    <div className={styles.leadUrl}>
                        <span>{gettext("oos_product.previously_seen.visit_store_btn")}</span>
                        <SVGIcon className={styles.linkChevron} name="chevron" />
                    </div>
                </div>
            </div>
        </LeadLink>
    );
}

OOSBuyOption.propTypes = {
    buyOption: BuyOptionPropType.isRequired,
    className: PropTypes.string,
    isWide: PropTypes.bool,
};

OOSBuyOption.defaultProps = {
    isWide: false,
};

export default OOSBuyOption;
